import { OUTPUT_TTL } from '../../../constants/Pac';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import moment from 'moment';
import { timerKey } from '../../../utils/timer-manager/timer-manager';
import type RootStore from '../../root-store';

/**
 * Screw controller
 *
 * @param rootStore
 * @param screwId
 * @param turnOn
 */
export const screwSwitch = (
  rootStore: RootStore,
  screwId: number,
  turnOn: boolean = true,
) => {

  if (!screwId) {
    return;
  }

  const { batchStore, devicesStore } = rootStore;
  const screw = devicesStore.getDeviceById(Number(screwId));
  const delay = turnOn ? screw.onDelay * 1000 || 0 : screw.offDelay * 1000 || 0;
  const s = batchStore.getDeviceStatus(screw.id);
  let port: number;
  let time: number | string = 2000;

  if (screw?.switchOnePNo && !screw?.switchOffPNo) {
    if ((turnOn && (batchStore.isOutputOn(screw.switchOnePNo) || s.active))) {
      return;
    }

    port = screw.switchOnePNo;
    time = turnOn ? OUTPUT_TTL : '0';

  } else if (screw?.switchOnePNo && screw?.switchOffPNo) {
    if ((turnOn && (batchStore.isOutputOn(screw.switchOnePNo) || s.active))
      || (!turnOn && (!batchStore.isOutputOn(screw.switchOnePNo) || !s.active))) {
      return;
    }

    port = (batchStore.isOutputOn(screw.switchOnePNo) || s.active) ? screw.switchOffPNo : screw.switchOnePNo;

  }

  batchStore.timers.clear(timerKey.custom('screw', screwId));

  batchStore.deviceStatus.set(screw.id, {
    ...s,
    status: turnOn ? DeviceStatus.SETTLING : DeviceStatus.IDLE,
    active: turnOn,
  });

  batchStore.timers.set(timerKey.custom('screw', screwId), () => {
    batchStore.setOutput(port, time);
    batchStore.deviceStatus.set(screw.id, {
      ...s,
      status: turnOn ? DeviceStatus.SETTLING : DeviceStatus.IDLE,
      active: turnOn,
      startTime: turnOn ? moment() : 0,
    });
  }, delay);
};
